// extracted by mini-css-extract-plugin
export var container = "_7q-0";
export var containerTopRight = "_7q-1";